import { render, staticRenderFns } from "./BriefOrder.vue?vue&type=template&id=45b0d3a8&"
import script from "./BriefOrder.vue?vue&type=script&lang=js&"
export * from "./BriefOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports